import { render, staticRenderFns } from "./CustomerPricerPage.vue?vue&type=template&id=ff8900e4&scoped=true&"
import script from "./CustomerPricerPage.vue?vue&type=script&lang=js&"
export * from "./CustomerPricerPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPricerPage.vue?vue&type=style&index=0&id=ff8900e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8900e4",
  null
  
)

export default component.exports